import { ErrorPageType } from '../../components/error-page/types';

export enum SCREENS {
    CALL = 'Call',
    CREATE_CALL = 'CreateCall',
    ERROR = 'Error',
    CONNECT_CALL = 'ConnectCall',
    PLAN_CALL = 'PlanCall',
    PLAN_BROADCAST = 'PlanBroadcast',
    CREATE_BROADCAST = 'CreateBroadcast',
    CONFERENCES_HISTORY = 'ConferencesHistory',
}

export interface PlanBroadcastHistoryState {
    caption?: string;
    description?: string;
    accessLevel?: string;
}

export type MainStackParamList = {
    [SCREENS.CALL]: { id: string; searchString?: string };
    [SCREENS.CREATE_CALL]: undefined;
    [SCREENS.CONNECT_CALL]: undefined;
    [SCREENS.PLAN_CALL]: undefined;
    [SCREENS.PLAN_BROADCAST]: PlanBroadcastHistoryState;
    [SCREENS.ERROR]: { type: ErrorPageType | undefined };
};
